/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-array-index-key */

import { selectTranslations } from 'app/pages/App/slice/selectors';
import React, { memo, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { EXCHANGE_TICKETS_SELECTED } from 'utils/constants';
import Countdown from 'app/pages/TicketRefund/components/Countdown';
import useCountDown from 'utils/hooks/useCountDown';
import * as _ from 'lodash';
import moment from 'moment';

interface Props {
  onOpenDialogNoti: any;
  onCloseDialogNoti: any;
  history?: any;
  modalError?: any;
  detailTicket: any;
  device: string;
}

const CountDownBox = memo(
  ({
    onOpenDialogNoti,
    history,
    detailTicket,
    modalError,
    onCloseDialogNoti,
    device,
  }: Props) => {
    const translations = useSelector(selectTranslations);
    const timeDistance = useMemo(() => {
      return (
        moment(
          detailTicket?.expiredAt?.datetimeDMYHIS,
          'HH:mm:ss DD/MM/YYYY',
        ).valueOf() -
        moment(
          detailTicket?.startTime?.datetimeDMYHIS,
          'HH:mm:ss DD/MM/YYYY',
        ).valueOf()
      );
    }, [
      detailTicket?.expiredAt?.datetimeDMYHIS,
      detailTicket?.startTime?.datetimeDMYHIS,
    ]);
    const { timeRemaining, resetCountDown } = useCountDown({
      time: timeDistance,
      onTimeout: () => {
        modalError(
          translations?.['b2b.txt.refundOrderExpried']?.replace(
            '{orderNumber}',
            detailTicket?.id,
          ) ?? '',
          () => {
            sessionStorage.removeItem(EXCHANGE_TICKETS_SELECTED);
            history.push('/account', {
              targetTab: 'tab-3',
            });
          },
        );
      },
    });
    useEffect(() => {
      resetCountDown(timeDistance);
      if (timeDistance <= 0) {
        resetCountDown(0);
        onOpenDialogNoti({
          type: 'ERROR',
          isShow: true,
          title: '',
          content:
            translations?.['b2b.txt.refundOrderExpried']?.replace(
              '{orderNumber}',
              detailTicket?.id,
            ) ?? '',
          closable: true,
          maskClosable: false,
          onCloseDialog: () => {
            onCloseDialogNoti();
            sessionStorage.removeItem(EXCHANGE_TICKETS_SELECTED);
            history.push('/account', {
              targetTab: 'tab-3',
            });
          },
        });
      }
    }, [resetCountDown, timeDistance]);
    return (
      <div
        className="d-flex justify-content-between"
        style={{
          width: '100%',
          background: 'white',
          padding:
            device === 'desktop' ? '40px 32px 16px 32px' : '24px 16px 16px',
          borderRadius: '20px 20px 0px 0px',
        }}
      >
        <p
          style={{
            marginBottom: 0,
            textTransform: 'uppercase',
            fontFamily: 'Be Vietnam Pro, sans-serif',
            fontWeight: 600,
            fontSize: 20,
            color: '#000000',
          }}
        >
          {translations ? translations['b2b.txt.change-tickets'] : ''}
        </p>
        {device !== 'mobile' && (
          <div style={{ flexShrink: 0 }}>
            {_.isInteger(timeRemaining) && <Countdown time={timeRemaining} />}
          </div>
        )}
      </div>
    );
  },
);

export default CountDownBox;
